export const statusColorMixin = {

    data() {
        return {
            statusColors: {
                invited: "#1976D2",
                reminded: "#baba3f",
                opened: "#709d70",
                started: "#777777",
                profile: "#927300",
                quota: "#FFAB00",
                quality: "#bf680c",
                duplicate: "#e75930",
                security: "#d20a0a",
                completed: "#388E3C",
                routedIn: "#1976D2",
                routedOut: "#ba3434",
            }
        }
    },
};